import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { FeatureFlagProvider } from 'contexts/FeatureFlagContext'
import { StandaloneProvisioningProvider } from 'contexts/StandaloneProvisioningContext'
import { setGoogleApiLicenseKey } from '@the-platform-group/component-library'

setGoogleApiLicenseKey(import.meta.env.VITE_GMAPS_KEY)

createRoot(document.getElementById('root')).render(
  <FeatureFlagProvider>
    <StandaloneProvisioningProvider>
      <App />
    </StandaloneProvisioningProvider>
  </FeatureFlagProvider>,
)
